<template>
  <el-table-column
    prop="extra_fields"
    label="Extra mezők"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      <el-tooltip v-if="scope.row.extra_fields.length" placement="top" style="max-width: 150px;" popper-class="permission-info-tooltip">
        <div slot="content">
          {{ scope.row.extra_fields.map(ef => ef.name).join(', ') }}
        </div>
        <el-tag v-if="scope.row.extra_fields.length" size="small" type="success">{{ scope.row.extra_fields.length }} mező</el-tag>
      </el-tooltip>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
